import React from "react";
import etiqueta from "../../../images/etiqueta_canales.png";

const HeroCanales = () =>(
    <>
        <section className="HeroCanales">
            <div className="wrap">
                <div>
                    <img src={etiqueta} className=""/>
                    <h3 className="titlesBig">VIAJA alrededor <br /> del MUNDO</h3>
                    <p>Con más de 100 canales en HD, para ver en <br />cualquiera de tus dipositivos. </p>
                </div>
            </div>
        </section>
    </>
)

export default HeroCanales;